<template>
  <!-- Message Info Right sidebar -->
  <right-sidebar-wrapper @close="onClose">
    <template v-slot:title>
      Messages Info
    </template>

    <template v-slot:actions>
      <a class="btn btn-outline-light" href="#" data-bs-toggle="dropdown">
        <i class="bx bx-dots-vertical-rounded"></i>
      </a>

      <div class="dropdown-menu dropdown-menu-end">
        <a href="#" class="dropdown-item">
          <span><i class="bx bx-x"></i></span>
          Close Chat
        </a>

        <a
          href="#"
          class="dropdown-item"
          data-bs-toggle="modal"
          data-bs-target="#mute-notification"
        >
          <span><i class="bx bx-volume-mute"></i></span>
          Mute Notification
        </a>

        <a
          href="#"
          class="dropdown-item"
          data-bs-toggle="modal"
          data-bs-target="#clear-chat"
        >
          <span><i class="bx bx-brush-alt"></i></span>
          Clear Message
        </a>

        <a
          href="#"
          class="dropdown-item"
          data-bs-toggle="modal"
          data-bs-target="#change-chat"
        >
          <span><i class="bx bx-trash-alt"></i></span>
          Delete Chat
        </a>

        <a
          href="#"
          class="dropdown-item"
          data-bs-toggle="modal"
          data-bs-target="#block-user"
        >
          <span><i class="bx bx-block"></i></span>
          Block
        </a>
      </div>
    </template>

    <div class="chat-body">
      <div class="messages">
        <div class="chats">
          <div class="chat-avatar ps-0">
            <img
              src="@/assets/img/avatar/avatar-2.jpg"
              class="rounded-circle avatar_chat"
              alt="image"
            />
          </div>

          <div class="chat-content">
            <div class="chat-profile-name">
              <h6>Mark Villiams<span>8:16 PM</span></h6>

              <div class="chat-action-btns ms-3">
                <div class="chat-action-col">
                  <a href="#" data-bs-toggle="dropdown">
                    <i class="bx bx-dots-horizontal-rounded"></i>
                  </a>

                  <div class="dropdown-menu chat-drop-menu dropdown-menu-end">
                    <a href="#" class="dropdown-item">
                      <span><i class="bx bx-info-circle"></i></span>
                      Message Info
                    </a>

                    <a href="#" class="dropdown-item">
                      <span><i class="bx bx-share"></i></span>
                      Reply
                    </a>

                    <a href="#" class="dropdown-item">
                      <span><i class="bx bx-smile"></i></span>
                      React
                    </a>

                    <a
                      href="#"
                      class="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#forward-message"
                    >
                      <span><i class="bx bx-reply"></i></span>
                      Forward
                    </a>

                    <a href="#" class="dropdown-item">
                      <span><i class="bx bx-star"></i></span>
                      Star Message
                    </a>

                    <a href="#" class="dropdown-item">
                      <span><i class="bx bx-dislike"></i></span>
                      Report
                    </a>

                    <a
                      href="#"
                      class="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#delete-message"
                    >
                      <span><i class="bx bx-trash"></i></span>
                      Delete
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="message-content fancy-msg-box">
              <div class="download-col">
                <message-info-img></message-info-img>
              </div>
            </div>
          </div>
        </div>

        <div class="message-info-box">
          <h6><span class="material-icons check-active">done_all</span>Read</h6>
          <span>Today at 7:12 AM</span>
        </div>

        <div class="message-info-box">
          <h6><span class="material-icons check">done_all</span>Delivered</h6>
          <span>Today at 7:09 AM</span>
        </div>

        <div class="message-info-box">
          <h6><i class="feather-check sent"></i>Sent</h6>
          <span>Today at 7:09 AM</span>
        </div>
      </div>
    </div>
  </right-sidebar-wrapper>
  <!-- Message Right sidebar -->
</template>

<script>
export default {
  data() {
    return {
      //
    };
  },

  methods: {
    onClose() {
      this.$eventHub.$emit('toggleThirdSidebar')
    },
  }
};
</script>
